import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ConfigurationService } from '../services/api/configuration.service';

export const ticketsEnabledGuard: CanActivateFn = () => {
  const router = inject(Router);
  const configurationService = inject(ConfigurationService);
  return configurationService.getTicketIntegrationEnabled().pipe(
    map(config => config.enabled ? true : router.parseUrl('/home-page')),
    catchError(() => of(router.parseUrl('/home-page'))),
  );
};
